(function() {
  'use strict';

  angular.module('component.blueprints', []);
})();
